/* eslint-disable react/prop-types */
/**
 * @file Flow.jsx
 * @exports FlowDefault
 */
import React from 'react'
import High from './High'
import Low from './Low'

const defaultColor = '#284047'

const FlowDefault = ({ high, low, style }) => <Flow high={high} low={low} style={style} />

export default FlowDefault

const Flow = ({ high, low, style }) => {
  const defaultStyle = {
    fill: 'none',
    stroke: defaultColor,
    strokeLinecap: 'round ',
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
  }

  const needleStyle = {
    ...defaultStyle,
    ...style,
    fill: 'none',
    strokeWidth: 1.5,
  }
  const tickStyle = {
    ...defaultStyle,
    ...style,
    strokeWidth: 1.5,
    strokeLinecap: 'square',
  }

  return (
    <svg
      id='flow-meter-icon'
      style={style}
      viewBox='0 0 75 75'
      version='1.1'
    >
      <description>flow meter icon</description>
      <title>flow meter</title>
      <g
        style={{
          ...style,
          transform: 'translate(14px, 13px) scale(1.4)',
        }}
      >
        <g id='right-side' style={{ ...defaultStyle, ...style }}>
          <rect width='2' height='19' x='31.0' y='16.6' />
          <rect width='0.7' height='12.4' x='29' y='19.9' />
        </g>

        <g
          id='main-icon'
          style={needleStyle}
        >
          <circle id='outer-circle' style={{ ...style, fill: 'none' }} cx='17.4' cy='8.6' r='7.5' />
          <circle id='needle-center' style={needleStyle} cx='17.5' cy='9' r='1.3' />
          <path id='needle' style={needleStyle} d='m 17.5,4.6 c 0,3.2 0,3.2 0,3.2' />
          <path style={tickStyle} d='m 12.1,8.6 c -1.9,0 -1.9,0 -1.9,0' />
          <path style={tickStyle} d='m 24.8,8.6 c -1.9,0 -1.9,0 -1.9,0' />
          <path style={tickStyle} d='m 17.5,3.2 c 0,-1.9 0,-1.9 -0,-1.9' />
          <path style={tickStyle} d='M 17.5,16 C 17.5,14 17.5,14 17.5,14' />
          <path d='m 13.9,15 c 2.3,4 2.3,4 2.3,4' />
          <path d='m 21.2,15 c -2.3,4 -2.3,4 -2.3,4' />
          <rect id='rect-under-dial' width='8.1' height='2.7' x='13.4' y='19.2' />
          <rect id='far-left' width='2' height='19' x='1.4' y='16.6' />
          <rect id='near-left' width='0.7' height='12.4' x='4.6' y='20' />
          <path d='m 6.3,21.8 21.8,0' />
          <path d='m 6.2,30.8 21.9,0' />
          <path d='m 13.7,30.8 c 0,0 1.3,2.7 4,2.8 2.7,0 4.2,-2.6 4.2,-2.6 v 0' />
        </g>
      </g>

      {high && (
        <g id='high' transform='translate(40,40) scale(.4)'>
          <High />
        </g>
      )}

      {low && (
        <g id='low' transform='translate(40,40) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
